import { WarningOutlined } from '@ant-design/icons'
import { useAppSelector } from '@store/hooks'
import { selectSelectedLegalDocument } from '@store/LegalDocumentReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input, Result } from 'antd'
import { useEffect } from 'react'

const Delete = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedLegalDocument())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Result
        icon={<WarningOutlined style={{ color: '#dc4446' }} />}
        title={'Are you sure ?'}
        subTitle={
          'Deleting this resource will also delete all resource associated. This action is immediate and cannot be undone.'
        }
      />
      <Form.Item name="id" hidden required rules={[]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="slug" hidden required rules={[]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  )
}

export default Delete
